module.exports = {"port":9226,"profile":"production","Access-Control-Allow-Origin":"*","login":"/user/login","api":{"ck":"hfs-csq","adminCk":"hcm_sid","clientCk":"hcm_sid","timeout":20000,"base":"https://portalhelper-lan.yunxiao.com"},"jwt":{"pk":"917104a6c7b328cb0373872275f4280f","expiresIn":"24h"},"cookie":{"key":"st","domain":".yunxiao.com","max":6000000}}


//////////////////
// WEBPACK FOOTER
// ./config/production.json
// module id = 233
// module chunks = 0